import { render, staticRenderFns } from "./_transactionLog.vue?vue&type=template&id=56247cb7&lang=pug&"
import script from "./_transactionLog.vue?vue&type=script&lang=js&"
export * from "./_transactionLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports